import { isBoolean } from '@tunasong/models'
import { NoteLib, ScaleLib } from '@tunasong/music-lib'
import type { FC } from 'react'
import { Note } from '../../note/note.js'
import type { NoteLabelProps } from './keyboard.js'
import styles from './label.module.css'

export const NoteLabel: FC<NoteLabelProps> = props => {
  const { note: providedNote, isAccidental, isActive, scale, label } = props
  const note = NoteLib.toNote(providedNote)
  const inScale = scale ? ScaleLib.noteInScale(scale, note) : undefined
  const renderDot = isBoolean(inScale) && label === 'note-scale'
  const renderLabel = label && label !== 'none'

  const dotColor =
    inScale === true
      ? 'var(--tuna-notes-inScale)'
      : inScale === false
        ? 'var(--tuna-notes-outOfScale)'
        : 'var(--tuna-notes-main)'

  return renderLabel ? (
    <div className={styles.labelContainer}>
      {renderDot ? (
        <div
          className={styles.dot}
          style={{
            backgroundColor: dotColor,
            alignSelf: isAccidental ? '' : 'center',
            left: isAccidental ? 2 : undefined,
          }}
        />
      ) : null}
      <Note
        note={note}
        scale={scale}
        className={styles.noteLabel}
        style={{
          color: isAccidental && !isActive ? 'white' : 'black',
        }}
      />
    </div>
  ) : null
}
